import React from 'react';
import EuropeCardGame from './components/EuropeCardGame';

function App() {
  return (
    <div className="App">
      <EuropeCardGame />
    </div>
  );
}

export default App;

